if(typeof require !== 'undefined') {
    CmsSelect2 = require('../../../Framework/assets/js/cms-select2');
    CmsDatepicker = require('../../../Framework/assets/js/cms-datepicker');
    SystemsightMediaUploader = require('../../../Project/Modules/Media/assets/media');
}

class CmsElementDuplicator {

    static init($context = null){
        var selector = "[data-element-duplicator]";
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if($(element).data('duplicator_instance')) return;
            $(element).data('duplicator_instance', new CmsElementDuplicator(element))
        });
    }

    constructor(element) {
        this.version = '0.0.1'
        this.element = element;
        this.$element = $(element);

        this.$element.find('[data-action="duplicate"][data-target="#'+element.id+'"]').on('click', function (){
            this.duplicateGroup();
        }.bind(this))

        this.$element.find('> .duplicated-elements').on('click', '[data-action="remove"]', function (e) {
            this.removeGroup($(e.currentTarget).closest('.duplicated-element'))
        }.bind(this))


        this.$element.find('[data-action="substract"]').on('click', function (){
            var subBtn = this.$element.find('[data-action="substract"]');

            this.removeGroup($(subBtn).parent().prev(".duplicated-elements").children().last());
        }.bind(this))

    }

    duplicateGroup(){
        let $duplicate = $(this.$element.find('> .original-element > .original-element-content').html());
        $duplicate = $duplicate.filter(':not([data-non-duplicable])')
        $duplicate.find('input[type="radio"]').attr("checked", null);
        $duplicate.find('input[type="checkbox"]').attr("checked", null);

        var $inputParent = $duplicate.find('.field_matrix');
        this.increaseIndex($inputParent, $inputParent.data('input_name'));

        let nextIndex = this.$element.find('> .duplicated-elements > .duplicated-element').length + 1;

        if(nextIndex > 0) {
            this.$element.find('[data-action="substract"]').addClass('shown');
        } else {
            this.$element.find('[data-action="substract"]').removeClass('shown');
        }

        $duplicate = this.#resetGroupValues($duplicate);
        $duplicate.find('.duplicated-element').remove();

        let $template =$(this.$element.find('> template[data-duplicated-element]').html());

        $template.find('.element-content').append($duplicate)

        this.$element.find('> .duplicated-elements').append($template)

        this.#invalidateGroupInputs();

        CmsElementDuplicator.init()
        if(typeof SumUpFields !== 'undefined'){
            SumUpFields.init();
        }
        if(typeof EstimateGridInput !== 'undefined'){
            EstimateGridInput.init();
        }
    }

    increaseIndex(element, input_name) {
        if ($('[data-input_name="' + input_name +'"]').length) {
            var i = 0;
            var regex = /\[i\-\d+\]/g;
            input_name = input_name.replace(regex, function(match) {
                i+=1;
                if (i===2) {
                    var num = parseInt(match.match(/\d+/)[0]) + 1;
                    return '[i-' + num + ']';
                }
                return match;
            });
            this.increaseIndex(element, input_name);
        } else {
            $(element).data('input_name', input_name);
            $(element).attr('data-input_name', input_name);
        }
    }

    #invalidateGroupInputs(){
        var self = this
        this.$element.find('> .duplicated-elements > .duplicated-element').each(function (index) {
            var nextIndex = index + 1;

            $(this).find(':input').each(function () {
                var indexPosition = 0
                $(this).parents('[data-element-duplicator]').each(function (index){
                    if(this === self.element){
                        indexPosition = index
                    }
                })

                if(this.name){
                    //var newName = this.name.replace(new RegExp("i:\\d+(?=]" + "\\[\\w+]".repeat(indexPosition*2) + "$)"), 'i:' + nextIndex)
                    var mIndex = -1;
                    var totalIndexes = this.name.split(/i-\d+/).length - 1

                    var newName = this.name.replace(/(i-\d+)/g, function(match, p1, offset, string){
                        mIndex++;
                        if(totalIndexes - mIndex - 1 === indexPosition){
                            return 'i-' + nextIndex;
                        }else{
                            return match;
                        }
                    })

                    this.setAttribute("name", newName)
                }
                if(this.id){
                    //var newId = this.id.replace(new RegExp("i-\\d+(?=__"+"\\d+__".repeat(indexPosition) + "[a-z0-9]+$)"), 'i-' + nextIndex)
                    mIndex = -1;
                    var newId = this.id.replace(/__(i-\d+)__/g, function(match, p1, offset, string){
                        mIndex++;
                        if(totalIndexes - mIndex - 1 === indexPosition){
                            return `__i-${nextIndex}__`;
                        }else{
                            return match;
                        }
                    })

                    this.setAttribute("id", newId)
                    if(this.type === 'radio' || this.type === 'checkbox'){
                        $(this).closest('.form-check').find('label').attr('for', newId)
                    }else{
                        $(this).closest('.form-group').find('label').attr('for', newId)
                    }

                }
            });
        })

        CmsSelect2.init(this.$element)
        CmsDatepicker.init(this.$element)
        SystemsightMediaUploader.prototype.initialize();
    }

    #resetGroupValues($duplicate){
        $duplicate.find('input:not([readonly]):not([type="radio"]):not([type="checkbox"]),textarea').val('');
        $duplicate.find('.select2-container').remove();
        $duplicate.find('select option').attr('selected', null);

        $duplicate.find('[data-input="select2"], [data-input="select2_tags"]')
            .removeClass('select2-hidden-accessible')
            .attr("data-select2-id", null)
            .attr("aria-hidden", null)
            .find('option').attr("data-select2-id", null)

        $duplicate.find('.media-uploader').each(function (){
            $(this).find('.upload-input-wrap').removeClass('d-none')
                .find('.current-counter').html(0)
            $(this).find('.media-item').remove();
        })

        $duplicate.find('[data-input="datepicker"]')
            .removeClass('flatpickr-input active')
            .attr('readonly', null)

        return $duplicate;
    }

    removeGroup($group){
        let nextIndex = this.$element.find('> .duplicated-elements > .duplicated-element').length - 1;

        if(nextIndex < 1) {
            this.$element.find('[data-action="substract"]').removeClass('shown');
        }

        $group.remove()
        this.#invalidateGroupInputs();
    }

}


if (typeof module === "object" && typeof module.exports === "object"){

    CmsElementDuplicator.init()
    //node modules support
    module.exports = CmsElementDuplicator;
}else{
    $(function(){
        CmsElementDuplicator.init()
    });
}